<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 48 48"
       role="presentation"
       @click="$emit('click')">
    <path :fill="iconColor" fill-rule="evenodd" d="M17.313 17.038a5.005 5.005 0 0 0-2.041 6.77l3.458 6.443a2.958 2.958 0 0 1-1.2-.727l-7.664-7.75a3.004 3.004 0 0 1 .023-4.243l7.75-7.665A2.996 2.996 0 0 1 19.749 9c.774 0 1.547.297 2.133.889l3.035 3.068-7.604 4.081zm17.196 2.645h-8.577c-2.757 0-5 2.243-5 5v5.442l-3.899-7.263a3.004 3.004 0 0 1 1.225-4.062l9.605-5.156a2.987 2.987 0 0 1 2.285-.229 2.985 2.985 0 0 1 1.777 1.455l2.584 4.813zm-3.602 6.768a2.558 2.558 0 0 1 2.555 2.555 2.559 2.559 0 0 1-2.555 2.555 2.56 2.56 0 0 1-2.556-2.555 2.559 2.559 0 0 1 2.556-2.555zm5.947 8.717a.999.999 0 0 0 0-1.414l-2.186-2.186c.5-.73.794-1.613.794-2.563a4.56 4.56 0 0 0-4.554-4.555 4.561 4.561 0 0 0-4.556 4.555 4.56 4.56 0 0 0 4.556 4.555c.837 0 1.61-.243 2.286-.638l2.246 2.246a.997.997 0 0 0 1.414 0zm-.021-13.485c1.654 0 3 1.345 3 3v10.901c0 1.654-1.346 3-3 3H25.932c-1.654 0-3-1.346-3-3v-10.9c0-1.656 1.346-3 3-3h10.9z"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>